import $ from 'jquery';

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

export const getCsrfToken = () => {
	return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
};

export const apiFetch = async (url, options = {}) => {
	const defaultHeaders = {
		'Content-Type': 'application/json',
		'X-Requested-With': 'XMLHttpRequest',
		'X-CSRF-TOKEN': getCsrfToken()
	};

	// Мержим базовые заголовки с теми, что могут прийти в options
	const config = {
		...options,
		headers: {
			...defaultHeaders,
			...options.headers
		}
	};

	return fetch(url, config);
};

export function handleValidationErrors(xhr, $form)
{
    if (xhr.status === 422) {
        let errors = xhr.responseJSON.errors;
        $form.find('[data-input-box]').removeClass('error');
        $form.find('.input-text[data-input-text]').empty();

        $.each(errors, function (field, messages) {
            let input = $form.find('[name="' + field + '"]');
            if (input.length) {
                let group = input.closest('[data-input-box]');
                group.addClass('error');

                group.find('.input-text[data-input-text]')
                    .html(messages.join('<br>'));
            }
        });
    } else {
        console.log('Server error, try later');
    }
}

$(document).ready(function () {
    // updateQty
    $.fn.updateQtyInput = function (qty, step, maxQty) {
        const defaultMax = 2000;
        maxQty = maxQty || defaultMax;

        if (isNaN(qty) || qty < 1) {
            this.val(step);
            return this;
        }

        if (step > 1 && qty % step !== 0) {
            qty += step - (qty % step);
        }

        if (qty > maxQty) {
            qty = maxQty;
        }

        this.val(qty);

        return this;
    };

    $.fn.productCounter = function (options) {
        const settings = $.extend({
            selectorPlus:  '[data-product-count-plus]',
            selectorMinus: '[data-product-count-minus]',
            selectorInput: '[name="qty"]',
            classDisabled: 'is-disabled'
        }, options);

        return this.each(function () {
            const $container = $(this);
            const $input = $container.find(settings.selectorInput);
            const $btnPlus = $container.find(settings.selectorPlus);
            const $btnMinus = $container.find(settings.selectorMinus);

            const step = parseInt($input.data('step'), 10) || 1;
            const maxQty = $input.is('[max]') ? parseInt($input.attr('max'), 10) : null;

            // функция обновления состояния кнопок
            function updateButtons()
            {
                const qty = parseInt($input.val(), 10) || step;

                if (qty <= step) {
                    $btnMinus.addClass(settings.classDisabled);
                } else {
                    $btnMinus.removeClass(settings.classDisabled);
                }

                if (maxQty && qty >= maxQty) {
                    $btnPlus.addClass(settings.classDisabled);
                } else {
                    $btnPlus.removeClass(settings.classDisabled);
                }
            }

            // ➕ Плюс
            $container.on('click', settings.selectorPlus, function (e) {
                e.preventDefault();
                if ($(this).hasClass(settings.classDisabled)) return;

                const qty = parseInt($input.val(), 10) || step;
                $input.updateQtyInput(qty + step, step, maxQty).trigger('change');
                updateButtons();
            });

            // ➖ Минус
            $container.on('click', settings.selectorMinus, function (e) {
                e.preventDefault();
                if ($(this).hasClass(settings.classDisabled)) return;

                const qty = parseInt($input.val(), 10) || step;
                $input.updateQtyInput(qty - step, step, maxQty).trigger('change');
                updateButtons();
            });

            // ✍️ Ручной ввод
            $input.on('blur change', function () {
                const qty = parseInt($input.val(), 10) || step;
                $input.updateQtyInput(qty, step, maxQty);
                updateButtons();
            });

            updateButtons();
        });
    };

    // tabs script
    $('[data-tab-container]').on('click', '[data-tab-link]', function (e) {
        e.preventDefault();
        const $btn = $(this);
        const $container = $btn.closest('[data-tab-container]');
        const targetName = $btn.data('tab-link');
        const $targetPane = $container.find('[data-tab-pane="' + targetName + '"]');
        const $activePane = $container.find('[data-tab-pane].active');
        if ($btn.hasClass('active')) {
            return;
        }
        $container.find('[data-tab-link]').removeClass('active');
        $btn.addClass('active');
        $activePane.fadeOut(300, function () {
            $(this).removeClass('active').removeAttr('style');
            $targetPane.fadeIn(300, function () {
                $(this).addClass('active').removeAttr('style');
            });
        });
    });

    // show more script
    $('[data-show-more]').each(function () {
        const $obj = $(this);
        const $items = $obj.find('[data-show-elements-item]');
        const $buttonContainer = $obj.find('[data-show-elements-button]');
        const $button = $obj.find('[data-show-more-btn]');

        const initialCount = parseInt($obj.data('initial'), 10) || 5;

        if ($items.length <= initialCount) {
            $buttonContainer.hide();
        }

        $button.on('click', function () {
            const isCollapsed = $items.filter(':hidden').length > 0;

            if (isCollapsed) {
                $items.slideDown(200);
                $obj.addClass('is-expanded');
            } else {
                $items.slice(initialCount).slideUp(200);
                $obj.removeClass('is-expanded');
            }
        });
    });

});

class ScrollAnimator {
	/**
	 * @param {string} selector - CSS селектор элементов для анимации
	 * @param {Object} options - Настройки для IntersectionObserver
	 */
	constructor(selector = '[data-anim-item]', options = {}) {
		this.selector = selector;

		// Дефолтные настройки обсервера (можно переопределить при создании класса)
		this.observerOptions = {
			root: null,
			rootMargin: '0px 0px -50px 0px',
			threshold: 0.35,
			...options // Сливаем дефолтные настройки с переданными
		};

		this.observer = null;
	}

	// Метод инициализации
	init() {
		const elements = document.querySelectorAll(this.selector);

		// Если элементов нет, ничего не делаем
		if (elements.length === 0) return;

		// Создаем обсервер и привязываем контекст (this) с помощью стрелочной функции
		this.observer = new IntersectionObserver((entries, observer) => {
			this.handleIntersection(entries, observer);
		}, this.observerOptions);

		// Начинаем следить за каждым элементом
		elements.forEach(element => {
			this.observer.observe(element);
		});
	}

	// Логика обработки пересечения
	handleIntersection(entries, observer) {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				// Добавляем класс
				entry.target.classList.add('_active');

				// Прекращаем слежку за элементом
				observer.unobserve(entry.target);
			}
		});
	}

	// Метод для полного отключения (полезно для SPA - React, Vue и т.д.)
	destroy() {
		if (this.observer) {
			this.observer.disconnect();
		}
	}
}

export class Accordion {
	// В options мы можем передавать настройки, например функцию onChange
	constructor(elementOrSelector, options = {}) {
		// Проверяем: если передали строку, ищем элемент. Если передали сам элемент - используем его.
		this.container = typeof elementOrSelector === 'string'
			? document.querySelector(elementOrSelector)
			: elementOrSelector;

		if (!this.container) return;

		this.items = this.container.querySelectorAll('[data-accordion-item]');
		this.activeItemClass = 'accordion__item--active';
		this.onChange = options.onChange || null;

		this.init();
	}

	init() {
		this.items.forEach(item => {
			const header = item.querySelector('[data-accordion-header]');

			// НОВОЕ: Синхронизируем ARIA-атрибуты при инициализации (на случай, если в HTML забыли прописать)
			const contentId = header.getAttribute('aria-controls');
			const content = document.getElementById(contentId);

			if (item.classList.contains(this.activeItemClass)) {
				header.setAttribute('aria-expanded', 'true');
				if (content) content.hidden = false;
			} else {
				header.setAttribute('aria-expanded', 'false');
				if (content) content.hidden = true;
			}

			// Обрати внимание: передаем кликнутый item в метод toggle
			header.addEventListener('click', () => this.toggle(item));
		});
	}

	toggle(clickedItem) {
		const isActive = clickedItem.classList.contains(this.activeItemClass);

		// 1. Закрываем ВСЕ элементы
		this.items.forEach(item => {
			item.classList.remove(this.activeItemClass);

			// НОВОЕ: a11y закрытие
			const header = item.querySelector('[data-accordion-header]');
			if (header) {
				header.setAttribute('aria-expanded', 'false'); // Говорим скринридеру, что закрыто
				const contentId = header.getAttribute('aria-controls');
				const content = document.getElementById(contentId);
				if (content) content.hidden = true; // Прячем панель
			}
		});

		// 2. Если кликнули по закрытому — открываем целевой
		if (!isActive) {
			clickedItem.classList.add(this.activeItemClass);

			// НОВОЕ: a11y открытие
			const header = clickedItem.querySelector('[data-accordion-header]');
			if (header) {
				header.setAttribute('aria-expanded', 'true'); // Говорим скринридеру, что открыто
				const contentId = header.getAttribute('aria-controls');
				const content = document.getElementById(contentId);
				if (content) content.hidden = false; // Показываем контент
			}

			// Если передана внешняя функция, вызываем её и отдаем ей открытый элемент
			if (this.onChange) {
				this.onChange(clickedItem);
			}
		}
	}
}

class SmartHeader {
	constructor(selector) {
		this.header = document.querySelector(selector);

		if (!this.header) return;

		this.lastScrollTop = 0;
		this.hiddenClass = 'header--hidden';
		this.headerHeight = this.header.offsetHeight;
		this.handleScroll = this.handleScroll.bind(this);
		this.updateHeight = this.updateHeight.bind(this);

		this.init();
	}

	init() {
		window.addEventListener('scroll', this.handleScroll);
		window.addEventListener('resize', this.updateHeight);
	}

	updateHeight() {
		this.headerHeight = this.header.offsetHeight;
	}

	handleScroll() {
		const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
		if (currentScroll > this.lastScrollTop && currentScroll > this.headerHeight) {
			this.header.classList.add(this.hiddenClass);
		}
		else {
			this.header.classList.remove(this.hiddenClass);
		}

		this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
	}
}

class UniversalTabs {
	constructor(selector) {
		this.container = document.querySelector(selector);

		if (!this.container) {
			console.warn(`Tabs container with selector "${selector}" not found.`);
			return;
		}

		this.buttons = this.container.querySelectorAll('[data-tabs-btn]');
		this.panels = this.container.querySelectorAll('[data-tabs-panel]');

		// Проверяем, совпадает ли количество кнопок и панелей
		if (this.buttons.length !== this.panels.length) {
			console.error('Количество кнопок и панелей контента не совпадает!');
			return;
		}

		this.init();
	}

	init() {
		this.buttons.forEach((btn, index) => {
			btn.addEventListener('click', () => {
				if (btn.classList.contains('tabs__btn--active')) return;
				this.switchTabs(index);
			});
		});
	}

	switchTabs(targetIndex) {
		// 1. Деактивируем текущие активные элементы
		this.buttons.forEach(btn => {
			btn.classList.remove('tabs__btn--active');
			btn.setAttribute('aria-selected', 'false'); // Говорим скринридеру: вкладка неактивна
		});

		this.panels.forEach(panel => {
			panel.classList.remove('tabs__panel--active');
			panel.setAttribute('hidden', ''); // Полностью скрываем неактивный контент от скринридера
		});

		// 2. Активируем целевые элементы по индексу
		this.buttons[targetIndex].classList.add('tabs__btn--active');
		this.buttons[targetIndex].setAttribute('aria-selected', 'true'); // Говорим скринридеру: вкладка выбрана

		this.panels[targetIndex].classList.add('tabs__panel--active');
		this.panels[targetIndex].removeAttribute('hidden'); // Делаем контент доступным для чтения

		// 3. Кастомное событие (опционально) для расширения функционала вовне
		this.container.dispatchEvent(new CustomEvent('tabChanged', {
			detail: { index: targetIndex }
		}));
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const animator = new ScrollAnimator();
	animator.init();

	const accordions = document.querySelectorAll('[data-accordion]');
	accordions.forEach(accordionElement => {
		new Accordion(accordionElement);
	});

	new SmartHeader('[data-header]');

	const tabsNode = document.querySelector('[data-tabs-main]');
	if (tabsNode) {
		const mainTabs = new UniversalTabs('[data-tabs-main]');
	}

});
